import { required, email } from "vuelidate/lib/validators";
const mznfirma = {
  data() {
    return {

      mznfirmaData: {
        Firmaadi: "",
        Firmaadresi: "",
        Telefon: "",
        Fax: "",
        Email: "",
        Vergino: "",
        Vergidairesi: "",
        Aciklama: "",
        Deleted: false,
        Adresilid: null,
        Adresilceid: null,
        Kvkk: false
      },
      FormDataType: {
        Firmaadi: { FieldName: "Firmaadi", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Firmaadi'), FieldType: "text" },
        Firmaadresi: { FieldName: "Firmaadresi", Field: "textarea", FieldTitle: this.$t('mznfirma.AddEdit.Firmaadresi') },
        Telefon: { FieldName: "Telefon", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Telefon'), FieldType: "text", Mask: "(###) ###-####" },
        Fax: { FieldName: "Fax", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Fax'), FieldType: "text", Mask: "(###) ###-####" },
        Email: { FieldName: "Email", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Email'), FieldType: "text" },
        Vergino: { FieldName: "Vergino", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Vergino'), FieldType: "text" },
        Vergidairesi: { FieldName: "Vergidairesi", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Vergidairesi'), FieldType: "text" },
        Aciklama: { FieldName: "Aciklama", Field: "textarea", FieldTitle: this.$t('mznfirma.AddEdit.Aciklama') },
        Adresilid: { FieldName: "Adresilid", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Adresilid'), ComboDataArray: [] },
        Adresilceid: { FieldName: "Adresilceid", Field: "input", FieldTitle: this.$t('mznfirma.AddEdit.Adresilceid'), ComboDataArray: [] },
        Kvkk: {
          FieldName: "Kvkk",
          Field: "input",
          FieldTitle: this.$t('mznfirma.AddEdit.Kvkk')
        }
      }
    }
  },
  validations: {
    FormData: {
      Firmaadi: { required },
      Firmaadresi: { required },
      Telefon: { required },
      Fax: { required },
      Email: { required, email },
      Vergino: { required },
      Vergidairesi: { required },
      Adresilid: { required },
      Adresilceid: { required },
      Aciklama: {},
      Kvkk:{}
    }

  },

  created() {

    let Page = {
      PageNumber: "1",
      PageSize: "9999"
    }

    this.ActionsFilterGet({ "Service": "OIlIlce", "Page": Page, Filter: "&Sadeceiller=true", }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Adresilid.ComboDataArray.push({ id: res.Data[i].Id, label: res.Data[i].Value })

      }

    });



  }



}
export default mznfirma